<template>
    <!-- 研修活动 -->
    <div class="activity_common_index" v-if="computeShowNoData">
        <div class="activity_title">
            <div class="title_template">
                <div class="activity_title_main">
                    <p>{{ modelTitle }}</p>
                    <div class="activity_title_tag">
                        <template
                            v-for="(item, index) in activityTag"
                            :key="`${index}_activity_box`"
                        >
                            <div
                                class="activity_tag"
                                :class="{
                                    active: item.val == currentActivityTag,
                                }"
                                v-show="
                                    item.show &&
                                    originActivityList[item.val] &&
                                    originActivityList[item.val].length !== 0
                                "
                                @click="changeTag(item.val)"
                            >
                                {{ item.label }}
                            </div>
                        </template>
                    </div>
                </div>
                <div class="more" @click="handleMore">
                    <span>更多</span><img src="~@/assets/img/more.png" alt="" />
                </div>
            </div>
            <div class="bar"></div>

            <div class="activity_body">
                <div
                    class="activity_img_body"
                    v-for="(item, index) in activityList[currentActivityTag]?.[
                        pageFormConfig.pageIndex - 1
                    ]"
                    @click="goDetail(item.activityId)"
                    :key="`activiy_body_${index}`"
                >
                    <LazyImage :src="item.activityCover" className="activity_img" />
                    <div class="activity_info">
                        <div class="activity_bar"></div>
                        <div class="activity_body_info">
                            <p class="activity_info_title">{{ item.title }}</p>
                            <div class="body_time">
                                <p>
                                    {{ convertTime(item.startTime) }} 至
                                    {{ convertTime(item.endTime) }}
                                </p>
                                <div
                                    class="body_statue"
                                    :style="`background-color: ${
                                        activityStatus[item.state]?.backgroundColor
                                    };`"
                                >
                                    {{ activityStatus[item.state]?.label }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="activity_pagination">
                <div
                    @click="handleDown"
                    :class="{
                        noData: checkHasDownData,
                        p_img_box: true,
                    }"
                >
                    <img
                        v-if="checkHasDownData"
                        src="~@/assets/img/resh-dis-left.png"
                        alt=""
                        style="left: 14px"
                    />
                    <img v-else src="~@/assets/img/resh-left.png" alt="" style="left: 14px" />
                </div>
                <div
                    @click="handleUp"
                    :class="{
                        noData: checkHasUpData,
                        p_img_box: true,
                    }"
                >
                    <img
                        v-if="checkHasUpData"
                        src="~@/assets/img/resh-dis-right.png"
                        alt=""
                        style="right: 14px"
                    />
                    <img v-else src="~@/assets/img/resh-right.png" alt="" style="right: 14px" />
                </div>
            </div>
        </div>
        <BigNoData
            v-if="!computeShowNoData"
            class="no-data"
            url="no-activity.png"
            info="暂无研修活动"
        />
    </div>
</template>
<script setup>
import { ref, reactive, computed, watch } from 'vue';
import { useStore } from 'vuex';
import BigNoData from '@/components/no-data.vue';
import { pageJump } from '@/global/location-transfer';
import { jumpHref } from '@/router/jumpHref.js';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { debounce, cloneDeep } from 'lodash';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';

const activityStatus = {
    1: {
        label: '关闭禁用',
        class: 'ended',
        color: '#fff',
        backgroundColor: '#BBBBBB',
    },
    11: {
        label: '未开始',
        class: 'unbegin',
        color: '#fff',
        backgroundColor: '#F99E53',
    },
    12: {
        label: '进行中',
        class: '',
        color: '#fff',
        backgroundColor: '#028AFF',
    },
    20: {
        label: '已结束',
        class: 'ended',
        color: '#fff',
        backgroundColor: '#BBBBBB',
    },
};
const activityTag = reactive([
    {
        val: 'jointActivityList',
        label: '联合教研',
        show: false,
    },
    {
        val: 'unionActivityList',
        label: '联盟教研',
        show: false,
    },
    {
        val: 'schoolActivityList',
        label: '校本教研',
        show: false,
    },
]);
const props = defineProps({
    modelTitle: {
        type: String,
        default: '',
    },
});

const debounceFunc = debounce(getActivityListVO, 500, { leading: true });

const store = useStore();
const router = useRouter();

const loading = ref(false); // 切换 tag 需要防抖，loading 需要前置

const pageFormCommonConfig = reactive({
    bizId2: '',
    sceneId: null,
});
const pageFormConfig = reactive({
    pageIndex: 1,
});
const activityList = reactive({
    jointActivityList: [],
    unionActivityList: [],
    schoolActivityList: [],
});
const originActivityList = ref({});
const computeShowNoData = computed(() => {
    const isShow = activityTag.some(item => activityList[item.val].length !== 0);
    return isShow;
});
// const showCurrentComponent = computed(() => {
//     const res = activityTag.some(
//         item => originActivityList.value[item.val] && originActivityList.value[item.val].length > 0,
//     );
//     return res;
// });
const initStatus = ref(true);

const currentActivityTag = ref('jointActivityList');

watch(
    () => store.state.common.institutionByBrand,
    val => {
        if (val?.id) {
            pageFormCommonConfig.bizId2 = val.id;
        }
    },
    { deep: true, immediate: true },
);

watch(
    () => pageFormCommonConfig,
    newVal => {
        if (newVal.bizId2 !== '' && newVal.sceneId) {
            loading.value = true;
            getActivityListVO();
        } else if (newVal.bizId2 !== '' && !newVal.sceneId) {
            getListThemeByBrand();
        }
    },
    {
        deep: true,
        immediate: true,
    },
);

function handleMore() {
    if (currentActivityTag.value == 'jointActivityList') {
        router.push({
            name: 'researchActivitySquare',
        });
    } else if (currentActivityTag.value == 'unionActivityList') {
        router.push({
            name: 'activitySquare',
        });
    } else {
        router.push({
            name: 'activitySquare',
            params: {
                type: 'school',
            },
        });
    }
}

function goDetail(currentId) {
    pageJump(jumpHref.activity.detail(currentId), true);
}

function handleDown() {
    if (!checkHasDownData.value) {
        pageFormConfig.pageIndex--;
    }
}
function handleUp() {
    if (!checkHasUpData.value) {
        pageFormConfig.pageIndex++;
    }
}

async function getListThemeByBrand() {
    try {
        const res = await G_transmit('getListThemeByBrand', {
            message: false,
            queries: {
                publishState: 1,
                themeType: 'union',
            },
        });
        if (res?.status?.code == 200) {
            pageFormCommonConfig.sceneId = res.data[0]?.id;
        }
    } catch (error) {
        console.log(error, 'getListThemeByBrand');
    }
}

async function getActivityListVO() {
    try {
        const res = await G_transmit('gatewayPage', {
            name: 'gatewayPage',
            params: {
                ...pageFormCommonConfig,
                pageIndex: 1,
                pageSize: 12,
            },
            message: false,
        });
        if (res?.status?.code == 200) {
            const { jointActivityList, schoolActivityList, unionActivityList } = res.data;
            originActivityList.value = cloneDeep(res.data);
            activityList.jointActivityList = convertArray(jointActivityList || []);
            activityList.schoolActivityList = convertArray(schoolActivityList || []);
            activityList.unionActivityList = convertArray(unionActivityList || []);
            // activityList.jointActivityList = []
            // activityList.schoolActivityList = [];
            // activityList.unionActivityList = [];

            if (activityList.schoolActivityList.length > 0) {
                activityTag[2].show = true;
            }
            if (activityList.unionActivityList.length > 0) {
                activityTag[1].show = true;
            }
            if (activityList.jointActivityList.length > 0) {
                activityTag[0].show = true;
            }
            if (initStatus.value) {
                initStatus.value = false;
                const r = Object.keys(activityList).find(item => activityList[item].length > 0);
                currentActivityTag.value = r;
            }
        }
    } catch (error) {
        console.log(error, 'getActivityListVO');
    } finally {
        loading.value = false;
    }
}

// 全量数据转换成一页三个
function convertArray(data) {
    const res = data.reduce((pre, val, index) => {
        if (index % 3 == 0) {
            return [
                ...pre,
                [
                    {
                        ...val,
                    },
                ],
            ];
        }
        pre[pre.length - 1].push({
            ...val,
        });
        return pre;
    }, []);
    return res;
}

function changeTag(config) {
    currentActivityTag.value = config;
    if (pageFormConfig.pageIndex == 1) {
        loading.value = true;
        debounceFunc();
    } else {
        pageFormConfig.pageIndex = 1;
    }
}

function convertTime(configTime) {
    return dayjs(configTime).format('YYYY年MM月DD日');
}

const checkHasDownData = computed(() => {
    return pageFormConfig.pageIndex <= 1;
});

const checkHasUpData = computed(() => {
    if (!activityList[currentActivityTag.value]) return false;
    return pageFormConfig.pageIndex >= activityList[currentActivityTag.value].length;
});

const showCurrentComponent = computed(() => {
    const res = activityTag.some(
        item => originActivityList.value[item.val] && originActivityList.value[item.val].length > 0,
    );
    return res;
});
</script>

<style lang="scss" scoped>
.activity_common_index {
    cursor: default;
    width: 1200px;
    margin: 0 auto;
    margin-top: 24px;
    margin-bottom: 30px;
    .title_template {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .more {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #999999;
            line-height: 19px;
            display: flex;
            align-items: center;
            span {
                margin-right: 4px;
            }
            img {
                width: 16px;
                height: 16px;
            }
        }
    }
    .activity_pagination {
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 30px;
            height: 30px;
            position: absolute;
            top: 2px;
        }
        .p_img_box {
            width: 34px;
            height: 34px;
            border: 1px solid #cfd7ff;
            position: relative;
        }
        .p_img_box:first-child {
            margin-right: 44px;
        }
        .noData {
        }
    }
    .bar {
        height: 3px;
        background: linear-gradient(116deg, #aac7ff 0%, #d4acff 100%);
        width: 100%;
        margin: 12px 0px 50px 0px;
    }
    .activity_body {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .activity_img_body {
            width: 30%;
            box-sizing: border-box;
            .activity_bar {
                flex: 0 0 2px;
                width: 2px;
                background: linear-gradient(134deg, #2671fe 0%, #a51fff 100%);
            }
            .activity_info {
                margin-top: 20px;
                display: flex;
            }
            .activity_body_info {
                padding-left: 16px;
                flex: 1;
                .activity_info_title {
                    font-size: 16px;
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    color: #000000;
                    line-height: 24px;
                }
            }
            .activity_img {
                width: 100%;
                height: 214px;
            }
        }
        .activity_img_body:not(:last-child) {
            margin-right: 5%;
        }
        .body_time {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            p {
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #666666;
                line-height: 14px;
                margin-right: 8px;
            }
            .body_statue {
                height: 22px;
                line-height: 22px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #ffffff;
                text-align: center;
                padding: 0px 6px;
            }
        }
    }
    .active {
        background: linear-gradient(134deg, #2671fe 0%, #a51fff 100%) !important;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff !important;
        line-height: 14px;
    }
    .activity_title_main {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        p {
            margin-right: 16px;
            font-size: 22px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            color: #000000;
            line-height: 22px;
        }
    }
    .activity_title_tag {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .activity_tag {
            margin-right: 16px;
            width: 88px;
            height: 28px;
            background: #f1f4ff;
            border: 1px solid #204adc;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #204adc;
            text-align: center;
            line-height: 28px;
        }
    }
}
.common-module-page {
    // width: 100vw;
    background: #ffffff;
    padding-bottom: 40px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
}
.activity-list {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}
.activity-list-item {
    box-sizing: border-box;
    width: 285px;
    height: 278px;
    background: #ffffff;
    border: 1px solid #e4e9ee;
    border-radius: 4px;
    // margin-top: 20px;
    margin-left: 20px;
    &:hover {
        border: none;
        box-shadow: 0px 4px 12px 0px rgba(37, 54, 82, 0.08);
        .list-item-img {
            margin-left: 0;
            margin-top: 0;
        }
    }
    .list-item-img {
        width: 285px;
        height: 160px;
        position: relative;
        margin-left: -1px;
        margin-top: -1px;
        .img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
        }
        .list-item-label {
            position: absolute;
            left: 12px;
            top: -5px;
        }
        .visit-num {
            display: inline-flex;
            align-items: center;
            min-width: 53px;
            height: 20px;
            padding: 0 10px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 24px 4px 4px 24px;
            position: absolute;
            right: 6px;
            bottom: 6px;
            font-size: 14px;
            color: #f7f8fa;
            line-height: 14px;
            img {
                width: 16px;
                height: 16px;
                margin-right: 4px;
            }
        }
    }
    .list-item-content {
        padding: 12px 16px 0;
        .activity-title {
            height: 42px;
            font-size: 16px;
            font-weight: bold;
            color: var(--color-black);
            line-height: 21px;
        }
        .activity-status {
            width: 46px;
            height: 16px;
            margin-top: 2px;
        }
        .creator-info {
            margin-top: 20px;
            font-size: 14px;
            color: #666666;
            line-height: 19px;
            .avatar {
                width: 24px;
                height: 24px;
                border-radius: 50%;
            }
            .creator-name {
                color: #222222;
                margin-left: 6px;
                margin-right: 8px;
            }
        }
    }
}
.activity-list-item:nth-child(4n + 1) {
    margin-left: 0;
}
.ellipsis-2 {
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.no-data {
    margin-top: 50px;
}
</style>
